import searchBox from './Main';
export default searchBox;
